var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"atlas"},[(_vm.isMobile)?_c('img',{staticClass:"atlas__img",attrs:{"src":require("../images/background/atlas_m.jpg"),"alt":"atlas"}}):_c('img',{staticClass:"atlas__img",attrs:{"src":require("../images/background/atlas.jpg"),"alt":"atlas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }